import React, {useEffect, useState} from 'react'
import {Box, CircularProgress} from '@mui/material'
import {colors} from '@/constants'
import TransCustom from '../i18next'

interface LoaderProps {
  isLoad: boolean
  local?: boolean
}

const Loader: React.FC<LoaderProps> = ({isLoad, local}) => {
  const [visible, setVisible] = useState<boolean>(isLoad)

  useEffect(() => {
    if (local) return
    if (isLoad) {
      setVisible(true)
    } else {
      const timer = setTimeout(() => {
        setVisible(false)
      }, 1000)

      return () => clearTimeout(timer)
    }
  }, [isLoad])

  return (
    <>
      {visible && (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100%">
          <CircularProgress style={{color: colors.white}} />
          <TransCustom i18nKey="1417" variant="h6" color={colors.white} />
        </Box>
      )}
    </>
  )
}

export default Loader
